module.exports = __webpack_public_path__ + "static/iphone-blue@2x-b092ecb070ae44ef45971de23e465e7b.png";